"use client";

import { useSyncExternalStore } from "react";

// Tailwind `lg` / `sm` breakpoints — keep in step with the grid's old columns-2/3/4.
const QUERIES = [["(min-width: 1024px)", 4], ["(min-width: 640px)", 3]];
const DEFAULT_COLUMNS = 2;
const getColumns = () => QUERIES.find(([query]) => window.matchMedia(query).matches)?.[1] ?? DEFAULT_COLUMNS;
function subscribe(onChange) {
  const lists = QUERIES.map(([query]) => window.matchMedia(query));
  lists.forEach(list => list.addEventListener("change", onChange));
  return () => lists.forEach(list => list.removeEventListener("change", onChange));
}
export function useColumnCount() {
  return useSyncExternalStore(subscribe, getColumns, _temp);
}
function _temp() {
  return DEFAULT_COLUMNS;
}